module.exports = __webpack_public_path__ + "img/V-R-1-unload-connect-shadow.1688d5d0.png";